import vSelect from 'vue-select'
import fetchItems from '@/scripts/vue/api-axios'

const categoryId = typeof window.category_id === "undefined" ? 911 : window.category_id

const faqListConfig = {
  components: {
    vSelect
  },
  mounted() {
    this.$Progress.start();
    fetchItems(`/yiiffaq?categoryId=${ categoryId }`)
      .then((items) => {
        this.faqs = items;
      })
      .then(() => {
        fetchItems(`/yiifcategory/faq`)
          .then((items) => {
            this.categories = items;
            this.getSelectOptions();
            this.$Progress.finish();

            // category attribute from url
            const categoryParam = parseInt(window.utils.getQueryStringParameter('faqCategory'));
            if ( categoryParam )
            {
              const currentCategory = this.selectOptions.filter(option => {
                return option.id === categoryParam
              });

              this.selectedCategory = currentCategory[0];
            }

          })
      });
  },
  data: () => ({
    faqs: [],
    categories: [],
    selectOptions: [],
    selectedCategory: null
  }),
  computed: {
    itemsForList() {
      return this.filteredItems;
    },
    rows() {
      return this.filteredItems.length
    },
    filteredItems() {
      return this.faqs.filter(item => {
        if (!this.selectedCategory || !this.selectedCategory.id) return true;
        const articleCategories = new Set(Object.keys(item.category));
        const selectedCategories = this.selectedCategory.categories;
        for(let index = 0; index < selectedCategories.length; index++) {
          if (articleCategories.has(selectedCategories[index].toString())) return true
        }
      })
    }
  },
  methods: {
    getSelectOptions() {
      this.categories.map(segment => {
        this.selectOptions.push({
          id: segment.id,
          title: null,
          group: segment.title
        });
        if(segment.children.length !== 0) {
          segment.children.map(category => {
            this.selectOptions.push({
              id: category.id,
              title: category.title,
              categories: category.children,
            });
          })
        }
      });


      /* show all option */
      if ( this.$refs.categorySelect?.placeholder )
      {
        // get Ids of all categories
        const allCategoriesIds = this.categories.map(category => category.id);

        // get placeholder from ref select
        const placeholder = this.$refs.categorySelect.placeholder;

        // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
        const clearOption = {
          categories: allCategoriesIds,
          id: 0,
          title: placeholder
        };

        this.selectOptions.unshift(clearOption);

        const defaultCategorySelected = parseInt(window.utils.getQueryStringParameter('faqCategory')) > 0; 
        if ( ! defaultCategorySelected )
        {
          this.selectedCategory = clearOption;
        }
      }
      /* ___ show all option ___ */
    },
    getPostLink(postCategories) {
      let link = postCategories[categoryId];
      if (this.selectedCategory && this.selectedCategory.id) {
        const categories = new Set(this.selectedCategory.categories);
        for (let key in postCategories) {
          if (categories.has(parseInt(key))) {
            return postCategories[key]
          }
        }
      }
      return link
    },
  },
  watch: {
    selectedCategory: function (newValue, oldValue) {

      if ( newValue.id )
      {
        window.utils.setQueryStringParameter('faqCategory', newValue.id);
      }
      else
      {
        window.utils.setQueryStringParameter('faqCategory', 0);
      }
      
    }
  }
}

export default faqListConfig